import type { ContextSort } from '@ardoq/common-helpers';
import type { EnhancedScopeData } from '@ardoq/data-model';
import type { Locale } from '@ardoq/locale';
import type { ArdoqId } from '@ardoq/api-types';
import { compareComponentIds } from '../compareComponentIds';
import { DependencyMapNode } from '../types';

const compareNodes = (
  nodeA: DependencyMapNode,
  nodeB: DependencyMapNode,
  sort: ContextSort,
  locale: Locale,
  scopeData: EnhancedScopeData,
  workspaceIds: ArdoqId[]
) =>
  nodeA.isComponent
    ? nodeB.isComponent
      ? compareComponentIds(
          nodeA.modelId,
          nodeB.modelId,
          sort,
          locale,
          scopeData,
          workspaceIds
        )
      : 1
    : nodeB.isComponent
      ? -1
      : 0;

const sortNodes = (
  nodes: DependencyMapNode[],
  sort: ContextSort,
  locale: Locale,
  scopeData: EnhancedScopeData,
  workspaceIds: ArdoqId[]
): DependencyMapNode[] =>
  nodes
    .map(node =>
      node.children
        ? {
            ...node,
            children: sortNodes(
              node.children,
              sort,
              locale,
              scopeData,
              workspaceIds
            ),
          }
        : node
    )
    .sort((a, b) => compareNodes(a, b, sort, locale, scopeData, workspaceIds));
export { sortNodes };
